<div class="d-flex justify-content-between align-items-center mb-6" *ngIf="valueFormGroup && valueFormControl">
  <label *ngIf="label" for="{{ controlName }}" class="col-12 col-lg-4 col-form-label {{ required ? 'required' : '' }}">{{ label }}</label>
  <div class="col-12 col-lg-8 {{ class }}" [formGroup]="valueFormGroup">
    <fieldset>
      <mat-select
        [formControlName]="controlName"
        (selectionChange)="handleChangeValue($event)"
        placeholder="{{ options && options.length > 0 ? placeholder : 'Tidak Ada Data' }}"
        [errorStateMatcher]="matcher"
      >
        <div *ngIf="options">
          <mat-option *ngFor="let opt of options" [value]="opt.value">
            <div class="block-ellipsis-customs">
              {{ customNameWithId || opt.code ? opt.code + ' - ' + opt.display : opt.display }}
            </div>
          </mat-option>
        </div>
      </mat-select>
    </fieldset>
    <mat-error *ngIf="isNotValidAndDirty && hasErrors"> {{ controlName }} is required </mat-error>
  </div>
</div>
